/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Shared state data
 * -----------------------------------------------------------------------------
 *
 * @namespace store
 */

var store = {
  // Elements via data attributes
  selectors: {
    sitePreloader: '[data-site-preloader]',
    productObj: '[data-product-json]',
    siteOverlay: '[data-site-overlay]',
    siteHeader: '[data-site-header]',
    headerSlider: '[data-header-slider]',
    searchLayer: '[data-search-layer]',
    newsletterPopup: '[data-newsletter-popup]',
    carousel: '[data-flickity]',
    productToolbarMobile: '[data-product-toolbar-mobile]',
    productTabs: '[data-product-tabs]',
    accountTabs: '[data-account-tabs]',
    singleOptionSelector: '[data-single-option-selector]',
    qtyContainer: '[data-qty-container]',
    qtyInput: '[data-qty-input]',
    cartItem: '[data-cart-item]',
    productForm: '[data-product-form]',
    cartForm: '[data-cart-form]',
    loginForm: '[data-login-form]',
    recoverForm: '[data-recover-form]',
    activateForm: '[data-activate-form]',
    passwordInput: '[data-password-input]',
    imageZoom: '[data-img-zoom]',
    allProduct: '[data-all-products]',
    productAccountObj: '[data-account-product-json]'
  },

  // Global objects
  currentTemplate: null,
  isLoading: false,
  moneyFormat: window.theme.moneyFormat,
  colorSwatchesEnabled: window.theme.colorSwatchesEnabled,
  sizeSwatchesEnabled: window.theme.sizeSwatchesEnabled,
  productExcludeTag: window.theme.productExcludeTag,

  // motivator bar
  salesMotivator: {
    topbarInitialText: window.theme.salesMotivatorTopBarInitial,
    topbarChangeText: window.theme.salesMotivatorTopBarChange,
    topbarSuccessText: window.theme.salesMotivatorTopBarSuccess,
    salesLimit: window.theme.salesMotivatorPriceLimit,
    Enabled: window.theme.salesMotivatorEnabled
  },

  // ReCharge Integration
  reChargeDiscountVariantId: null,
  customer: {
    email: window.theme.customersEmail,
    id: window.theme.customersID,
    name: window.theme.customersName,
    addresses: window.theme.addresses,
    tags: window.theme.customerTags
  },

  // Pick Your Plan
  pickYourPlan: {
    selectedProduct: '',
    variantsGroup: [],
    subscription_id: '',
    shipping_interval_unit_type: '',
    shipping_interval_frequency: '',
    mostPopular: '',
    selectedStage: '',
    try_type: 'plastic_tray',
    grass: {
      selectedState: '',
      grassType: '',
      grassImage: ''
    },
    frequency: {
      selectedFrequency: '',
      frequencyImage: '',
      frequencyId: ''
    }
  },
  // Prepaid Gift
  standardPriceEveryWeek: {
    oneDelivery: '',
    threeDelivery: '',
    sixDelivery: ''
  },
  standardPriceEveryTwoWeek: {
    oneDelivery: '',
    threeDelivery: '',
    sixDelivery: ''
  },
  standardPriceEveryThreeWeek: {
    oneDelivery: '',
    threeDelivery: '',
    sixDelivery: ''
  },
  standardPriceEveryFourWeek: {
    oneDelivery: '',
    threeDelivery: '',
    sixDelivery: ''
  },
  mediumPriceEveryWeek: {
    oneDelivery: '',
    threeDelivery: '',
    sixDelivery: ''
  },
  mediumPriceEveryTwoWeek: {
    oneDelivery: '',
    threeDelivery: '',
    sixDelivery: ''
  },
  mediumPriceEveryThreeWeek: {
    oneDelivery: '',
    threeDelivery: '',
    sixDelivery: ''
  },
  mediumPriceEveryFourWeek: {
    oneDelivery: '',
    threeDelivery: '',
    sixDelivery: ''
  },
  largePriceEveryWeek: {
    oneDelivery: '',
    threeDelivery: '',
    sixDelivery: ''
  },
  largePriceEveryTwoWeek: {
    oneDelivery: '',
    threeDelivery: '',
    sixDelivery: ''
  },
  largePriceEveryThreeWeek: {
    oneDelivery: '',
    threeDelivery: '',
    sixDelivery: ''
  },
  largePriceEveryFourWeek: {
    oneDelivery: '',
    threeDelivery: '',
    sixDelivery: ''
  },
  xlPricePriceEveryWeek: {
    group1: {
      oneDelivery: '',
      threeDelivery: '',
      sixDelivery: ''
    },
    group2: {
      oneDelivery: '',
      threeDelivery: '',
      sixDelivery: ''
    },
    group3: {
      oneDelivery: '',
      threeDelivery: '',
      sixDelivery: ''
    }
  },
  xlPriceEveryTwoWeek: {
    group1: {
      oneDelivery: '',
      threeDelivery: '',
      sixDelivery: ''
    },
    group2: {
      oneDelivery: '',
      threeDelivery: '',
      sixDelivery: ''
    },
    group3: {
      oneDelivery: '',
      threeDelivery: '',
      sixDelivery: ''
    }
  },
  xlPriceEveryThreeWeek: {
    group1: {
      oneDelivery: '',
      threeDelivery: '',
      sixDelivery: ''
    },
    group2: {
      oneDelivery: '',
      threeDelivery: '',
      sixDelivery: ''
    },
    group3: {
      oneDelivery: '',
      threeDelivery: '',
      sixDelivery: ''
    }
  },
  xlPriceEveryFourWeek: {
    group1: {
      oneDelivery: '',
      threeDelivery: '',
      sixDelivery: ''
    },
    group2: {
      oneDelivery: '',
      threeDelivery: '',
      sixDelivery: ''
    },
    group3: {
      oneDelivery: '',
      threeDelivery: '',
      sixDelivery: ''
    }
  },
  pickYourPrepaid: {
    selectedProduct: '',
    variantsGroup: [],
    subscription_id: '',
    shipping_interval_unit_type: '',
    shipping_interval_frequency: '',
    charge_interval_frequency: '',
    mostPopular: '',
    selectedStage: '',
    selectedWeek: '',
    selectedMonth: '',
    selectedProductprice: '',
    grass: {
      selectedState: '',
      grassType: '',
      grassImage: ''
    },
    frequency: {
      selectedFrequency: '',
      frequencyImage: '',
      frequencyId: ''
    },
    month: {
      selectedMonth: ''
    }
  },
  ready: false,
  has_package: true,
  selected_package: '',
  cartHasGift: false
};

export default store;